let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("82hg3")).then(() => parcelRequire('1JiUs'));